import React from 'react';
import PropTypes from 'prop-types';
import css from './BriefShelf.css';

export default function RenderNestedValue({ title, value, depth = 0 }) {
    try {
        const paddingLeft = depth * 5 + 10;

        if (['string', 'number', 'boolean'].includes(typeof value)) {
            return (
                <div className={css.briefItem} style={{ paddingLeft: `${paddingLeft}px` }}>
                    <span className={css.briefTitle}>{title || ''}</span>
                    <span className={css.briefValue}>{String(value)}</span>
                </div>
            );
        }

        if (Array.isArray(value)) {
            return (
                <div className={css.briefNestedContainer} style={{ paddingLeft: `${paddingLeft}px` }}>
                    <span className={css.briefTitle}>{title || ''}</span>
                    <div className={css.briefNestedContent}>
                        {value.map((item, index) => (
                            <div key={`${title}-${index}`} className={css.briefArrayItem}>
                                {item && typeof item === 'object' ? (
                                    Object.entries(item).map(([subTitle, subValue]) => (
                                        <RenderNestedValue
                                            key={`${title}-${subTitle}`}
                                            title={subTitle}
                                            value={subValue}
                                            depth={depth + 1}
                                        />
                                    ))
                                ) : (
                                    <span className={css.briefValue}>{String(item || '')}</span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        if (value && typeof value === 'object') {
            return (
                <div className={css.briefNestedContainer} style={{ paddingLeft: `${depth * 16 + 5}px` }}>
                    <span className={css.briefTitle}>{title || ''}</span>
                    <div className={css.briefNestedContent}>
                        {Object.entries(value).map(([subTitle, subValue]) => (
                            <RenderNestedValue
                                key={`${title}-${subTitle}-${depth}`}
                                title={subTitle}
                                value={subValue}
                                depth={depth + 1}
                            />
                        ))}
                    </div>
                </div>
            );
        }
    } catch (error) {
        console.error('Error rendering nested value:', error);
        return (
            <div className={css.briefItem} style={{ paddingLeft: `${depth * 16 + 5}px` }}>
                <span className={css.briefTitle}>{title || ''}</span>
                <span className={css.briefValue}>Error displaying value</span>
            </div>
        );
    }

    return null;
}

RenderNestedValue.propTypes = {
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object, PropTypes.array]),
    depth: PropTypes.number,
};
